import { Dialog } from './dialog';

class UpsellProductTypeManager {
  section: HTMLElement;

  constructor(kitCard: HTMLElement) {
    this.section = kitCard;
    this.init();
  }

  private init(): void {
    const rows = Array.from(this.section.querySelectorAll<HTMLElement>('.kit-card--row'));
    rows.forEach((row) => this.initRow(row));
  }

  private initRow(row: HTMLElement): void {
    const upsellProductId = row.dataset.upsellProductId;
    const dialog = row.nextElementSibling as HTMLDialogElement | null;
    if (!dialog || dialog.tagName !== 'DIALOG') return;

    const rowSelect = row.querySelector<HTMLSelectElement>('select');
    const dialogSelect = dialog.querySelector<HTMLSelectElement>('select');
    const selects = [rowSelect, dialogSelect].filter((s): s is HTMLSelectElement => s !== null);
    const overlays = dialog.querySelectorAll<HTMLImageElement>('.overlay-img-to-change');
    const openButton = row.querySelector<HTMLButtonElement>('button.link');
    const closeButtons = Array.from(dialog.querySelectorAll<HTMLElement>('button.close'));

    if (openButton) {
      // stopPropagation prevents the click from bubbling to the parent <label>
      // which would otherwise toggle the kit radio button
      openButton.addEventListener('click', (e) => e.stopPropagation());
      new Dialog(dialog, [openButton], closeButtons);
    }

    selects.forEach((select) => {
      select.addEventListener('change', (event: Event) => {
        const target = event.target as HTMLSelectElement;
        const { value, options, selectedIndex } = target;

        selects.forEach((other) => {
          if (other !== target) other.value = value;
        });

        const selectedOption = options[selectedIndex] as HTMLOptionElement;
        const phoneLoopImage = selectedOption?.dataset.phoneLoopImage;
        if (phoneLoopImage) {
          overlays.forEach((overlay) => {
            overlay.src = phoneLoopImage;
            overlay.srcset = phoneLoopImage;
          });
        }

        // Update data-pX-match-variant on the .kit-card div
        // This is read by product-form.ts handleKitAddToCart to know which variant to add
        if (upsellProductId) {
          const slot = ['p1', 'p2', 'p3'].find((p) => this.section.dataset[p] === upsellProductId);
          if (slot) this.section.dataset[`${slot}MatchVariant`] = value;
        }
      });
    });
  }
}

export { UpsellProductTypeManager };
